import { useQuery } from '@tanstack/react-query';

import { dashboardApi, qk, usersApi } from '@/api';
import { useCompanyBasics, useIsOffice } from '@/features/auth/session';
import { todayInTz } from '@/lib/dates';

/** W2 data: refetches every 60 s (doc 08). */
export function useDashboardToday(date: string) {
  return useQuery({
    queryKey: qk.dashboard.today(date),
    queryFn: () => dashboardApi.getToday(date),
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}

/** Nav badges: field-added workers waiting for a role, missing submissions after cutoff. */
export function useDashboardBadge(): { people: number; missing: number } {
  const isOffice = useIsOffice();
  const { tz } = useCompanyBasics();
  const today = todayInTz(tz);
  const users = useQuery({
    queryKey: qk.users.list({ role: 'worker' }),
    queryFn: () => usersApi.listUsers({ role: 'worker' }),
    enabled: isOffice,
    staleTime: 60_000,
  });
  const dash = useQuery({
    queryKey: qk.dashboard.today(today),
    queryFn: () => dashboardApi.getToday(today),
    enabled: isOffice,
    refetchInterval: 60_000,
  });
  const people = users.data?.items.filter((u) => u.addedByUserId).length ?? 0;
  const missing = dash.data?.pastCutoff ? dash.data.summary.missing : 0;
  return { people, missing };
}
